// extracted by mini-css-extract-plugin
module.exports = {"hidden":"join-team-sidebar-callout_hidden_3Ay","openNavDrawer":"join-team-sidebar-callout_openNavDrawer_34_"};